import Image from "next/image";
import type { ReactNode } from "react";

import { cn } from "@/utils/lib";

import { Button } from "../ui/button";

export interface EmptyStateProps {
  image?: string;
  title: string | ReactNode;
  description?: string | ReactNode;
  buttonText?: string;
  buttonVariant?: "default" | "outline";
  classNames?: string;
  onClick?: () => void;
}
export const EmptyState = ({
  image = "/assets/empty-3.png",
  title,
  description,
  buttonText,
  buttonVariant = "outline",
  classNames,
  onClick,
}: EmptyStateProps) => {
  return (
    <div
      className={cn(
        `
          flex flex-col items-center justify-center gap-2 overflow-hidden px-4
          text-center
        `,
        classNames,
      )}
    >
      {image && (
        <Image
          src={image}
          className="mb-4"
          width={160}
          height={160}
          alt="Empty State"
          priority
        />
      )}
      <h2
        className="
          font-sans text-xl font-medium wrap-break-word text-muted-foreground
        "
      >
        {title}
      </h2>
      {description && (
        <div
          className="
            m-auto mb-2 text-center leading-6 wrap-break-word text-muted
            md:max-w-[80%]
          "
        >
          {description}
        </div>
      )}
      {!!(buttonText && typeof onClick === "function") && (
        <Button variant={buttonVariant} size="lg" onClick={onClick}>
          {buttonText}
        </Button>
      )}
    </div>
  );
};
